import React from "react";
import { container} from "./NotAvailableMessage.module.scss";

export const NotAvailableMessage = (): JSX.Element => {
    return (
        <div className={container}>
            <h4>There are no rooms available matching your search criteria.</h4>
            <span>Please try selecting alternate dates, modifying your search options, or choosing an alternate property.</span>
        </div>
    );
};
export default NotAvailableMessage;
